import CommentsContainer from "./components/Comments/CommentsContainer";
import NotificationsContainer from "./components/Notifications/NotificationContainer";

const _classmap = {
  Comments: CommentsContainer,
  Notifications: NotificationsContainer,
};

export default _classmap;
